import React from 'react';
import { IconButton, Tooltip, SxProps, Theme, Box } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

export type SortDirection = 'asc' | 'desc' | null;

interface SortToggleProps {
  sortDirection: SortDirection;
  onSortChange: (direction: SortDirection) => void;
  fieldName?: string;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

const DirectionSortToggle: React.FC<SortToggleProps> = ({ 
  sortDirection, 
  onSortChange, 
  fieldName = 'field',
  size = 'small',
  disabled = false,
  sx
}) => {
  const handleSortClick = (): void => {
    let newDirection: SortDirection;
    
    if (sortDirection === 'asc') {
      newDirection = 'desc';
    } else if (sortDirection === 'desc') {
      newDirection =  'asc';
    } else {
      newDirection = 'asc';
    }
    
    onSortChange(newDirection);
  };

  const getSortIcon = (): React.ReactElement => {
    switch (sortDirection) {
      case 'asc':
        return <ArrowUpwardIcon />;
      case 'desc':
        return <ArrowDownwardIcon />;
      default:
        return <ArrowDownwardIcon />;
    }
  };

  const getTooltipText = (): string => {
    switch (sortDirection) {
      case 'asc':
        return `Oldest ${fieldName} first`;
      case 'desc':
        return `Newest ${fieldName} first`;
      default:
        return `Newest ${fieldName} first`;
    }
  };

  return (
    <Tooltip title={getTooltipText()}>
      <Box>
        <IconButton
          size={size}
          onClick={handleSortClick}
          disabled={disabled}
          sx={{
            '&:hover': {
              backgroundColor: 'action.hover'
            },
            '&.Mui-disabled': {
              color: 'action.disabled'
            },
            ...sx
          }}
        >
          {getSortIcon()}
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default DirectionSortToggle;
